import { FormControl, FormGroup, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { BaseLayerComponent } from "../base-layer/base-layer.component";
import { Component, Input } from "@angular/core";

@Component({
  template: "",
  standalone: false,
})
export abstract class WfsLayerComponent extends BaseLayerComponent {
  supportFormats = ["GEOJSON", "json", "application/json", "text/javascript"];

  format: any;

  useBbox = false;

  @Input()
  url: string;

  isAuthRequired: boolean;

  hide: boolean = true;

  username: string = "";

  password: string = "";

  isLoading: boolean;

  changed: boolean = true;

  features: any[];

  form = new FormGroup({
    url: new FormControl("", Validators.required),
    username: new FormControl(""),
    password: new FormControl(""),
  });

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected matDialog: MatDialog,
  ) {
    super(http, viewerConfigurationService, matDialog);
  }

  onAuthRequireChange(event: any) {
    this.isAuthRequired = event.value;
    this.changed = true;
    document.getElementById("lblError").innerHTML = "";
  }

  fieldsCompleted() {
    if (this.isAuthRequired) {
      return this.form.get("username").value !== "" && this.form.get("password").value !== "" && this.changed;
    }

    return this.changed;
  }

  changeInput() {
    this.changed = true;
  }

  usernameExists() {
    return this.form.get("username").value.length > 0;
  }

  passwordExists() {
    return this.form.get("password").value.length > 0;
  }

  changeCheckFeature(checked: boolean, feature: any) {
    feature.checked = checked;
  }

  setBbox(event) {
    this.useBbox = event.checked;
  }

  getLayerInformation() {
    this.isLoading = true;
    this.changed = false;
    document.getElementById("lblError").innerHTML = "";
    const { url } = this;

    this.username = this.form.get("username").value;
    this.password = this.form.get("password").value;

    let credentials;
    if (this.isAuthRequired && this.username && this.username.length && this.password && this.password.length) {
      credentials = `${this.username}:${this.password}`;
    }
    this.getCapabilities(url, credentials);
  }

  getCapabilitiesSuccess(data: Object) {
    let capability;
    const formatter = this.getWFSFormatter();
    try {
      const json = formatter.xml2js(data);
      // this object contains all the GetCapabilities data
      capability = json.WFS_Capabilities;
    } catch (e) {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "Bad data was returned";
      return;
    }
    if (!capability || !capability.FeatureTypeList) {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "No layers were returned";
      return;
    }

    let formats = this.getFormats(capability);
    formats = formats.filter((f) => this.supportFormats.includes(f));

    if (formats.length === 0) {
      document.getElementById("lblError").innerHTML = "OutputFormats not supported";
    } else {
      this.format = formats[0];
      this.features =
        capability.FeatureTypeList.FeatureType instanceof Array
          ? capability.FeatureTypeList.FeatureType
          : [capability.FeatureTypeList.FeatureType];
      document.getElementById("lblError").innerHTML = "";
    }
    this.isLoading = false;
    this.changed = true;
    this.cdr.detectChanges();
    this.loadLayers();
    document.getElementById("lblError").innerHTML = "";
  }

  getFormats(capability) {
    let formats;
    formats = capability.OperationsMetadata.Operation.find((o) => o._name === "GetFeature").Parameter?.find(
      (p) => p._name === "outputFormat",
    ).AllowedValues.Value;
    if (!formats) {
      formats = capability.OperationsMetadata.Parameter.find((o) => o._name === "outputFormat").AllowedValues.Value;
    }
    return formats.map((f) => f.__text);
  }

  getCapabilitiesError() {
    this.isLoading = false;
    this.cdr.detectChanges();
    document.getElementById("lblError").innerHTML = "Failed to load url";
  }

  abstract getWFSFormatter();

  abstract loadLayers();
}
